/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 17:48
 *
 */

import { Component, EventEmitter, inject, input, Output, ChangeDetectionStrategy } from '@angular/core';

import { GridstackModule } from 'gridstack/dist/angular';
import {
  ActionsBarBuilder,
  ActionsBarComponent,
} from '@infodata-group/inf-commons-desktop';
import { Widget } from '../../../engine/widget/widget';
import { ActionEvent, StandardAction } from '@infodata-group/inf-commons';
import { DashboardService } from '../../../service/dashboard.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'infl-widget-wrapper',
  standalone: true,
  imports: [
    GridstackModule,
    TranslatePipe,
    ActionsBarComponent
],
  templateUrl: './widget-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './widget-wrapper.component.scss',
})
export class WidgetWrapperComponent {
  private readonly dashboardService = inject(DashboardService);

  protected readonly actionBarConfig = new ActionsBarBuilder()
    .setIsTitleBold(true)
    .setMarginLeft(10)
    .build();

  public widget = input.required<Widget>();
  public actions = input<StandardAction[]>();

  @Output() actionClick = new EventEmitter<ActionEvent>();

  protected onActionClick($event: ActionEvent): void {
    switch ($event.action.name) {
      case 'close':
        this.dashboardService.toggleVisibilityWidget(this.widget(), false);
        break;
      default:
        this.actionClick.emit($event);
        break;
    }
  }
}
